import { Button, Link } from 'evergreen-ui';
import { Client, writeGroupToCsv } from '../models';
import React, { ReactElement } from 'react';

import { FiDownload } from 'react-icons/fi';
import { today } from '../util';

interface DownloadMembersButtonParams {
  client: Client;
}

async function downloadMembers(client: Client): Promise<void> {
  const csv = await writeGroupToCsv(client.memberGroups);
  const dataStr = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
  const downloadAnchor = document.getElementById('download-members')!;
  downloadAnchor.setAttribute('href', dataStr);
  downloadAnchor.setAttribute('download', `${client.name}_EligibilityPortal_${today()}.csv`);
  downloadAnchor.click();
}

export const DownloadMembersButton: (params: DownloadMembersButtonParams) => ReactElement = ({ client }) => (
  <>
    <Link id="download-members" display="none" />
    <Button height={24} marginLeft={8} display="inline" onClick={() => downloadMembers(client)}>
      <FiDownload
        style={{
          position: 'relative',
          top: '1px',
          marginRight: '8px',
        }}
      />
      Download membership CSV
    </Button>
  </>
);
